import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { OidcSecurityService } from 'angular-auth-oidc-client';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(private _oidcSecurityService: OidcSecurityService) {}

  private setHeaders(request: HttpRequest<any>) {
    if (request.url) {
      if (new URL(request.url).pathname.startsWith('/api')) {
        const token = this._oidcSecurityService.getAccessToken();
        if (token) {
          request = request.clone({
            setHeaders: {
              Authorization: `Bearer ${token}`,
            },
          });
        }
      }
    }

    return request;
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    request = this.setHeaders(request);

    return next.handle(request);
  }
}
